<template>
  <div class="main">
    <base-card v-for="toast in toasts" :key="toast.name">
      <v-card-title>{{ toast.name }}</v-card-title>
      <v-card-text>{{ toast.text }}</v-card-text>
      <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        {{ toast.priceS }} <br />
        {{ toast.priceL }}
      </v-card-actions>
    </base-card>
    <base-card color="#DC143C">
      <v-card-title class="flex text-center">Додатоци</v-card-title>
    </base-card>
    <base-card v-for="side in sides" :key="side.name">
      <v-card-title>{{ side.name }}</v-card-title>
      <v-card-text>{{ side.text }}</v-card-text>
      <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        {{ side.priceS }} <br />
        {{ side.priceL }}
      </v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toasts: [
        {
          name: "Печурки и кашкавал",
          text: "Печурки и млечен кашкавал",
          priceS: "мал 120 ден.",
          priceL: "голем 140 ден.",
        },
        {
          name: "Пилешка шунка и кашкавал",
          text: "Пилешка шунка и млечен кашкавал",
          priceS: "мал 100 ден.",
          priceL: "голем 120 ден.",
        },
        {
          name: "Кулен и кашкавал",
          text: "Кулен и млечен кашкавал",
          priceS: "мал 140 ден.",
          priceL: "голем 160 ден.",
        },
        {
          name: "Печеница и кашкавал",
          text: "Печеница и млечен кашкавал",
          priceS: "мал 140 ден.",
          priceL: "голем 160 ден.",
        },
        {
          name: "Посен тост",
          text: "Печурки и растителен кашкавал",
          priceS: "мал 100 ден.",
          priceL: "голем 130 ден.",
        },
      ],
      sides: [
        {
          name: "Млечен кашкавал",
          text: "Со млечен кашкавал",
          priceS: "во мал тост + 30 ден.",
          priceL: "во голем тост + 40 ден.",
        },
        {
          name: "Помфрит",
          text: "Додаток помфрит во тост",
          priceS: "мал +30 ден.",
          priceL: "голем +40 ден.",
        },
        {
          name: "Печурки",
          text: "Додаток печурки",
          priceS: "во мал тост + 30 ден.",
          priceL: "во голем тост + 40 ден.",
        },
        {
          name: "Салата",
          text: "Додаток салата",
          priceS: "во мал тост + 20 ден.",
          priceL: "во голем тост + 30 ден.",
        },
      ]
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 80vh;
  background: transparent;
}
</style>
